module.exports = __webpack_public_path__ + "img/FullSizeRender.bd154ad5.jpg";